// extracted by mini-css-extract-plugin
module.exports = {"footer":"yCojh","buttons":"_3900H","buttonLeft":"_28zMy"};